<template>
  <router-view />
</template>

<script>
export default {
  name: "sales",
};
</script>